import type { FaireProductEntity } from "../../entity_types/product";

export const p_cpgk9zrusy: FaireProductEntity = {
  token: "p_cpgk9zrusy",
  type: "product",
  name: "Silver Puffy Star Huggie Hoop Earrings",
  brandToken: "b_bd3e23fe",
  brandName: "ZAD",
  imageUrl:
    "https://cdn.faire.com/fastly/11bc489342dff20e659cfe93f073b7398048b3ecb4704bb92dba27abeb13ec98.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d757788e76d15d151cef80c5cf94ef3c1bf80cb966d23bff7b80a38c1f8fda40.jpeg",
  ],
  priceDollars: 5,
  description:
    'A charming pair of silver puffy star huggie hoop earrings. These adorable hoops are designed to make you shine like a star. The puffy star charms, add a touch of whimsy and playfulness to your look. The silver tone complements any outfit, making them a versatile accessory for all occasions. With a comfortable huggie style, these earrings ensure a secure fit without compromising on style. Embrace your inner star and elevate your style with these charming earrings.\n\n• Made in China\n• Shining silver star puffy hoops\n• Measures: 1/2 x 5/8"\n• Materials: Silver Tone Metal',
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:04.938Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
